import WorkExperienceItem from "components/WorkExperience";
import { Img, Text, Heading } from "../../components";
import React from "react";

const works = [
    {
        workTitle: "Kitchen Staff",
        startDate: (
            <>
                SEP
                <br />
                2024
            </>
        ),
        endDate: "NOW",
        jobTitle: "Kitchen Staff",
        companyName: (
            <>
                Stadspaviljoen
                <br />& MOOD B.V
            </>
        ),
        jobDescription: "Currently working as a dishwasher at two restaurants. This is my first job since moving to Eindhoven for my study HBO-ICT at Fontys.",
        illustration: "images/img_resume_bro_1_1.png"
    },
    {
        workTitle: "Software Developer",
        startDate: (
            <>
                AUG
                <br />
                2023
            </>
        ),
        endDate: (
            <>
                JAN
                <br />
                2024
            </>
        ),
        jobTitle: "Software Developer",
        companyName: "Estrategy",
        jobDescription: "I worked here as an intern during my studies at Scalda. I was responsible for developing a mobile scheduling app for employees in the healthcare sector, using C#, MAUI, and ASP.NET.",
        illustration: "images/img_coding_bro_1.png",
        position: "right"
    },
    {
        startDate: (
            <>
                JUN
                <br />
                2020
            </>
        ),
        endDate: (
            <>
                AUG
                <br />
                2024
            </>
        ),
        jobTitle: "Kitchen Staff",
        companyName: "Groede podium",
        jobDescription: "Started as a dishwasher and became an all-rounder over the years. Mostly worked in the kitchen but can do everything. In the last two years, I’ve also directed the staff on some days.",
        illustration: "images/img_chef_amico_1.png"
    }
]


export default function WorkExperience() {
    return (
        <section id="work" className="container-xs flex min-h-screen">
            <div className="flex flex-col gap-[82px] md:gap-[61px] sm:gap-[41px]">
                <div className="flex flex-col gap-[110px]">
                    <Heading size="heading2xl" as="h1" className="text-[96px] font-bold text-white-a700 md:text-[48px]">
                        <span className="text-white-a700">Work</span>
                        <span className="text-orange-a200">.</span>
                    </Heading>

                    {works.map(work => (
                        <WorkExperienceItem companyName={work.companyName} workTitle={work.workTitle}
                            position={work.position}
                            illustrationSrc={work.illustration}
                            jobDescription={work.jobDescription} jobTitle={work.jobTitle}
                            startDate={work.startDate} endDate={work.endDate} />
                    ))}


                </div>
            </div>
        </section>
    );
}
